import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {},
  tableHead: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '8fr 40fr 8fr 8fr 8fr 9fr 1fr',
    color: theme.palette.text.secondary,
    alignItems: 'center',
    padding: '0 0 0 12px',
    marginBottom: 4,
    marginTop: 4,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12,
    [theme.breakpoints.down(768)]: {
      gridTemplateColumns: '1.1fr 1.1fr 0.1fr'
    }
  }
}))

export default useStyles
